import React from 'react';
import { makeStyles, Theme, useTheme } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import TextField from '@material-ui/core/TextField';
import { VseCourseEditTemplate } from '../types';

const useStyles = makeStyles((theme: Theme) => ({
  root: {
    padding: theme.spacing(1),
  },
}));

export interface VseCourseHeaderGridProps {
  data: VseCourseEditTemplate,
  decodeSeason: (id: number) => string | undefined,
  decodeUniversity: (id: number) => string | undefined,
  decodeUniversityTerm: (seasonID: number, universityID: number, termCode: string) => string | undefined,
  decodeCourseStatus: (code: string) => string | undefined,
}

export function VseCourseHeaderGrid(props: VseCourseHeaderGridProps) {
  const theme = useTheme();
  const classes = useStyles(theme);
  const courseCode = props.data.courseCode ? props.data.courseCode : '';

  return (
    <div className={classes.root}>
      <Grid container>
        <Grid container>
          <Grid item xs={12} md={3}>
            <TextField
              label='VSE Season'
              required
              value={props.decodeSeason(props.data.seasonID)}
              InputProps={{
                readOnly: true,
                disableUnderline: true,
              }}
            />
          </Grid>
          <Grid item xs={12} md={6}>
            <TextField
              label='Course Offering University'
              required
              value={props.decodeUniversity(props.data.univID)}
              InputProps={{
                readOnly: true,
                disableUnderline: true,
              }}
            />
          </Grid>
          <Grid item xs={12} md={3}>
            <TextField
              label='Course Offering Term / Semester'
              required
              value={props.decodeUniversityTerm(props.data.seasonID, props.data.univID, props.data.termCode)}
              InputProps={{
                readOnly: true,
                disableUnderline: true,
              }}
            />
          </Grid>
        </Grid>
        <Grid container>
          <Grid item xs={12} md={3}>
            <TextField
              label='Course Code'
              required
              value={courseCode}
              InputProps={{
                readOnly: true,
                disableUnderline: true,
              }}
            />
          </Grid>
          <Grid item xs={12} md={6}>
            <TextField
              label='Course Title'
              required
              value={props.data.courseTitle}
              InputProps={{
                readOnly: true,
                disableUnderline: true,
              }}
            />
          </Grid>
          <Grid item xs={12} md={3}>
            <TextField
              label='Status'
              required
              value={props.decodeCourseStatus(props.data.statusCode)}
              InputProps={{
                readOnly: true,
                disableUnderline: true,
              }}
            />
          </Grid>
        </Grid>
      </Grid>
    </div>
  );
}
